import Omy from "../Omy";
import { OMY_SETTING, OmyConst } from "../OmyConst";
import OMath from "../utils/OMath";

export default class GameSizeManager {
    constructor() {
    }

    updateGameSize(container, dx, dy, isScreenPortrait, withChildren = true) {
        if (Omy.isDesktop && !OMY_SETTING.ALLOW_DESK_SIZE) return;
        Omy.isScreenPortrait = isScreenPortrait;

        this._screenPos = isScreenPortrait ? "v_" : (Omy.isDesktop) ? "d_" : "m_";
        const children = [container, ...container.children];

        // do not remove next line (this method will not work without it)
        Omy.isDesktop && false && console.log(children.length);

        for (let i = 0, l = children.length; i < l; i++) {
            const child = children[i];
            const conf = child.json;
            if (!conf) continue;
            if (conf["noCheckSize"]) continue;

            if (child !== container && conf["deepPosition"] && withChildren) {
                this.updateGameSize(child, dx, dy, isScreenPortrait);
            }

            if (container.isAlign && container.canvas && conf["deepPosition"] && withChildren) {
                for (let j = 0; j < container.canvas.children.length; j++) {
                    this.updateGameSize(container.canvas.children[j], dx, dy, isScreenPortrait);
                }
            }

            let screenHeight = this._param(conf, "screen_height", null);
            if (isScreenPortrait && screenHeight) {
                if (Array.isArray(screenHeight)) {
                    let height = 0;
                    for (let j = 0; j < screenHeight.length; j++) {
                        if (Omy.HEIGHT >= screenHeight[i]) height = screenHeight[i];
                    }
                    if (height) screenHeight = height;
                } else {
                    if (Omy.HEIGHT < screenHeight) screenHeight = 0;
                }
            }
            let scaleX = this._params(conf, "scale", "scaleX", 1);
            let scaleY = this._params(conf, "scale", "scaleY", 1);
            const maxScaleX = this._params(conf, "max_scale", "max_scale_x", 0);
            const maxScaleY = this._params(conf, "max_scale", "max_scale_y", 0);
            const maxScaleLimitDx = this._params(conf, "max_scale_limit", "max_scale_limit_dx", 0);
            const maxScaleLimitDy = this._params(conf, "max_scale_limit", "max_scale_limit_dy", 0);
            if ((maxScaleX || maxScaleY) && ((dx > 0 && maxScaleX && maxScaleLimitDx) || (dy > 0 && maxScaleY && maxScaleLimitDy))) {
                if (maxScaleX && maxScaleY) {
                    const dxPercent = dx / maxScaleLimitDx;
                    const dyPercent = dy / maxScaleLimitDy;
                    const percent = isScreenPortrait ? dyPercent : Math.min(dxPercent, dyPercent);
                    scaleX = percent >= 1 ? maxScaleX : scaleX + (maxScaleX - scaleX) * percent;
                    scaleY = percent >= 1 ? maxScaleY : scaleY + (maxScaleY - scaleY) * percent;
                }
                else if (maxScaleX) {
                    const dxPercent = dx / maxScaleLimitDx;
                    scaleX = dxPercent >= 1 ? maxScaleX : scaleX + (maxScaleX - scaleX) * dxPercent;
                } else if (maxScaleY) {
                    const dyPercent = dy / maxScaleLimitDy;
                    scaleY = dyPercent >= 1 ? maxScaleY : scaleY + (maxScaleY - scaleY) * dyPercent;
                }
            }
            if (isScreenPortrait && screenHeight && conf["scale_" + String(screenHeight)]) {
                scaleX = conf["scale_" + String(screenHeight)];
                scaleY = conf["scale_" + String(screenHeight)];
            }
            if (child.scale.x !== scaleX)
                child.scale.x = scaleX;
            if (child.scale.y !== scaleY)
                child.scale.y = scaleY;
            if (conf["type"] === OmyConst.OMY_BUTTON_TWEEN) {
                child._saveScaleX = scaleX;
                child._saveScaleY = scaleY;
            }
            let x = this._param(conf, "x");
            if (isScreenPortrait && screenHeight && conf["x_" + String(screenHeight)]) x = conf["x_" + String(screenHeight)];
            let childX, posX = x + this._param(conf, "dx") * scaleX;
            const moveDx = dx * this._param(conf, "sdx");
            childX = posX + moveDx;
            let y = this._param(conf, "y");
            if (isScreenPortrait && screenHeight && conf["y_" + String(screenHeight)]) y = conf["y_" + String(screenHeight)];
            let childY, posY = y + this._param(conf, "dy") * scaleY;
            const moveDy = dy * this._param(conf, "sdy");
            childY = posY + moveDy;
            const limitMaxSdx = this._param(conf, "limit_max_x");
            const limitMaxSdy = this._param(conf, "limit_max_y");
            const limitMinSdx = this._param(conf, "limit_min_x");
            const limitMinSdy = this._param(conf, "limit_min_y");
            if (limitMaxSdx) childX = Math.min(childX, limitMaxSdx);
            if (limitMaxSdy) childY = Math.min(childY, limitMaxSdy);
            if (limitMinSdx) childX = Math.max(childX, limitMinSdx);
            if (limitMinSdy) childY = Math.max(childY, limitMinSdy);
            const leftLimit = this._param(conf, "left_limit");
            const rightLimit = this._param(conf, "right_limit");
            const topLimit = this._param(conf, "top_limit");
            const bottomLimit = this._param(conf, "bottom_limit");
            if (dx > 0 && leftLimit && (
                (moveDx > 0 && leftLimit > 0 && moveDx > leftLimit) ||
                (moveDx < 0 && leftLimit < 0 && moveDx < leftLimit)
            )) childX = posX + leftLimit;
            if (dy > 0 && topLimit && (
                (moveDy > 0 && topLimit > 0 && moveDy > topLimit) ||
                (moveDy < 0 && topLimit < 0 && moveDy < topLimit)
            )) childY = posY + topLimit;

            if (dx > 0 && rightLimit) {
                if (moveDx > 0 && rightLimit > 0 && dx - moveDx > rightLimit) childX = posX + (dx - rightLimit);
                else if (moveDx < 0 && rightLimit < 0 && -1 * (dx + moveDx) < rightLimit) childX = posX - (dx + rightLimit);
            }
            if (dy > 0 && bottomLimit) {
                if (moveDy > 0 && bottomLimit > 0 && dy - moveDy > bottomLimit) childY = posY + (dy - bottomLimit);
                else if (moveDy < 0 && bottomLimit < 0 && -1 * (dy + moveDy) > bottomLimit) childY = posY - (dy + moveDy);
            }
            if (child.x !== childX)
                child.x = childX;
            if (child.y !== childY)
                child.y = childY;

            if (this._checkParams(conf, "rotate"))
                child.rotation = OMath.toRadians(this._param(conf, "rotate"));
            if (this._checkParams(conf, "alpha"))
                child.alpha = this._param(conf, "alpha", 1);
            if (isScreenPortrait && screenHeight && conf["alpha_" + String(screenHeight)]) child.alpha = conf["alpha_" + String(screenHeight)];

            if (conf.hasOwnProperty("portrait")) {
                let visible = (conf["portrait"] && isScreenPortrait) || (!conf["portrait"] && !isScreenPortrait);
                visible = child.hasOwnProperty("forceVisible") ? visible && child.forceVisible : visible;
                child.visible = visible;
            }

            if (child.hitArea) {
                if (this._checkParams(conf, "hitArea_x"))
                    child.hitArea.x = this._param(conf, "hitArea_x");
                if (this._checkParams(conf, "hitArea_y"))
                    child.hitArea.y = this._param(conf, "hitArea_y");
                if (this._checkParams(conf, "hitArea_width"))
                    child.hitArea.width = this._param(conf, "hitArea_width");
                if (this._checkParams(conf, "hitArea_height"))
                    child.hitArea.height = this._param(conf, "hitArea_height");
                if (this._checkParams(conf, "hintAreaRect")) {
                    let hintAreaRect = this._param(conf, "hintAreaRect");
                    for (let hintAreaRectKey in hintAreaRect) {
                        if (hintAreaRectKey === "type" || hintAreaRectKey === "debug") continue;
                        child.hitArea[hintAreaRectKey] = hintAreaRect[hintAreaRectKey];
                    }
                }
            }
            if (conf["type"] === OmyConst.OMY_SPRITE) {
                if (this._checkParams(conf, "texture")) {
                    let childTexture = child.textureName;
                    if (conf.hasOwnProperty(this._screenPos + "texture")) childTexture = conf[this._screenPos + "texture"];
                    else if (conf.hasOwnProperty("texture")) childTexture = conf["texture"];
                    if (isScreenPortrait && screenHeight && conf["texture_" + String(screenHeight)]) childTexture = conf["texture_" + String(screenHeight)];
                    if (child.textureName !== childTexture)
                        child.texture = childTexture;
                }
            }
            if (conf["type"] === OmyConst.OMY_BUTTON || conf["type"] === OmyConst.OMY_BUTTON_TWEEN) {
                if (this._checkParams(conf, "out")) {
                    child.changeTextures(this._param(conf, "out"), this._param(conf, "over"), this._param(conf, "out"), this._param(conf, "block"));
                }
            }

            if (conf["type"] === OmyConst.OMY_CONTAINER && child.isAlign) {
                if (conf.hasOwnProperty("align")) {
                    if (this._checkParams(conf, "align"))
                        child.newAlignContainer(this._param(conf, "align"));
                } else {
                    if (this._checkParams(conf, "alignContainer"))
                        child.newAlignContainer(this._param(conf, "alignContainer"));
                }
            }

            if (conf["type"] === OmyConst.OMY_TEXT_BITMAP || conf["type"] === OmyConst.OMY_TEXT_NUMBER_BITMAP ||
                conf["type"] === OmyConst.OMY_TEXT_FONT || conf["type"] === OmyConst.OMY_TEXT_NUMBER_FONT ||
                conf["type"] === OmyConst.OMY_MULTI_STYLE_TEXT_FONT || conf["type"] === OmyConst.OMY_MULTI_STYLE_TEXT_NUMBER_FONT) {
                let textParam = child.oneLine;
                if (this._checkParams(conf, "oneLine"))
                    textParam = this._param(conf, "oneLine");
                if (child.oneLine !== textParam)
                    child.oneLine = textParam;
                if (this._checkParams(conf, "locConst"))
                    child.text = this._param(conf, "locConst");
                if (this._checkParams(conf, "text"))
                    child.text = this._param(conf, "text");

                if (conf.hasOwnProperty("fontSize")) {
                    textParam = child.fontSize;
                    if (this._checkParams(conf, "fontSize"))
                        textParam = this._param(conf, "fontSize");
                    if (isScreenPortrait && screenHeight && conf["fontSize_" + String(screenHeight)])
                        textParam = conf["fontSize_" + String(screenHeight)];
                    if (child.fontSize !== textParam) child.fontSize = textParam;
                }
                if (this._checkParams(conf, "width")) {
                    child.resetCheckScale();
                    let width = this._param(conf, "width");
                    if (isScreenPortrait && screenHeight && conf["width_" + String(screenHeight)]) width = conf["width_" + String(screenHeight)];
                    child.textMaxWidth = width;
                }
                if (this._checkParams(conf, "height")) {
                    child.resetCheckScale();
                    child.textMaxHeight = this._param(conf, "height");
                }
                if (this._checkParams(conf, "align"))
                    child.align = this._param(conf, "align");
                if (this._checkParams(conf, "alignV"))
                    child.alignV = this._param(conf, "alignV");
            }
        }
    }

    /**     * @private     */
    _param(conf, paramName, defaultValue = 0) {
        let result = defaultValue;
        if (conf.hasOwnProperty(this._screenPos + paramName)) result = conf[this._screenPos + paramName];
        else if (conf.hasOwnProperty(paramName)) result = conf[paramName];
        return result;
    }

    /**     * @private     */
    _params(conf, paramOneName, paramTwoName, defaultValue = 0) {
        let result = defaultValue;
        if (conf.hasOwnProperty(this._screenPos + paramOneName)) result = conf[this._screenPos + paramOneName];
        else if (conf.hasOwnProperty(this._screenPos + paramTwoName)) result = conf[this._screenPos + paramTwoName];
        else if (conf.hasOwnProperty(paramOneName)) result = conf[paramOneName];
        else if (conf.hasOwnProperty(paramTwoName)) result = conf[paramTwoName];
        return result;
    }

    /**     * @private     */
    _checkParams(conf, ...arg) {
        for (let i = 0; i < arg.length; i++) {
            if (conf.hasOwnProperty("v_" + arg[i]))
                return true;
        }
        return false;
    }
}
